<script>
	import { fly, fade } from "svelte/transition"

	let valueName = "",
		valueEmail = "",
		valueMessage = "",
		nameError = false,
		emailError = false,
		messageError = false,
		amountMessage,
		disabled = false,
		form

	$: if(valueMessage === undefined) {
		amountMessage = 0
	} else {
		amountMessage = 0 + valueMessage.length
	}

	const handleName = () => {
		nameError = true
		setTimeout( () => nameError = false, 2500)
	}
	const handleEmail = () => {
		emailError = true
		setTimeout( () => emailError = false, 2500)
	}
	const handleMessage = () => {
		messageError = true
		setTimeout( () => messageError = false, 2500)
	}

	const handleSubmit = async e => {
		e.preventDefault()
		// Here, we deleted the spaces and create a new variable whath we will use in the validation of the form
		let newValueName = valueName.replace(/\s+/g, ""),
			newValueEmail = valueEmail.replace(/\s+/g, "")

		// Here weo go to declarate the lets if the inputs are validate for can send the form, we will go to call with the name of the input and to the end we will add de work "Comprobation", if are true, the form for that part can send, else the form for that part not can send, when the three parts being true, the formulary can send

		let nameComprobation = false,
			emailComprobation = false,
			messageComprobation = false

		// let for validation with regular expresions if the email are correct like email

		let validateEmail = /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z]{2,}))$/.test(newValueEmail)


		// Valdations of the labels like name, email and mesagge

		if(newValueName.length <= 5){
			handleName()
			nameComprobation = false
		} else {
			nameComprobation = true
		}
		if(validateEmail === false && newValueEmail.length <= 5){
			handleEmail()
			emailComprobation = false
		} else {
			emailComprobation = true
		}
		if(valueMessage.length < 75) {
			handleMessage()
			messageComprobation = false
		} else {
			messageComprobation = true
		}

		// Conditional what evaluate if the all labels are true for to send the email

		if(nameComprobation && emailComprobation && messageComprobation) {
			// Let disabled for to desabilite or activate the button
			disabled = true

			const Toast = Swal.mixin({
				toast: true,
				position: 'top-end',
				showConfirmButton: false,
				timer: 4000,
				timerProgressBar: false,
				didOpen: (toast) => {
					Swal.showLoading()
				}
			})

			Toast.fire({
				title: "Su email se esta enviando"
			})


			const formData = new FormData(form)
			const response = await fetch("https://submit-form.com/RzxTDisl", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"Accept": "application/json",
	 			},
				body: JSON.stringify({
			        Nombre: formData.get("name"),
			        Correo: formData.get("email"),
			        Mensaje: formData.get("message")
		        })
			})
			if(response.ok){
				form.reset()
				Swal.fire({
					title: "Se ha enviado!!!",
					text: "Muchas gracias por contactarme",
					icon: "success",
					confirmButtonText: "De nada",
					background: "var(--secundary)",
					classCustom: {
						confirmButton: "btn"
					},
					confirmButtonColor: "var(--background-btn)"
				})
			} else{
				form.reset()
				Swal.fire({
					title: "No se ha enviado",
					text: "Ocurrio un error, vuelvelo a intentar",
					icon: "error",
					background: "var(--secundary)",
					confirmButtonText: "Entiendo",
					classCustom: {
						confirmButton: "btn"
					},
					confirmButtonColor: "var(--background-btn)"
				})
			}
			disabled = false
		}
	}

	// Swal.fire({
	// 	title: "Se ha enviado!!!",
	// 	text: "Muchas gracias por contactarme",
	// 	confirmButtonText: "De nada",
	// 	background: "var(--secundary)",
	// 	icon: "success",
	// 	classCustom: {
	// 		confirmButton: "btn"
	// 	}
	// })
</script>
<form
	class="Form"
	on:submit={handleSubmit}
	bind:this={form}>
	<div class="Form-content">
		<div class="Form-content--name">
			<label for="name">Tu nombre completo<span>*</span></label>
			<input
				type="text"
				name="name"
				id="name"
				placeholder="Nombre"
				bind:value={valueName}
			>
			{#if nameError}
				<div class="Form-content--error" in:fly out:fade>
					<div class="Form-content--error__element">
						Coloque su nombre completo
					</div>
				</div>
			{/if}
		</div>
		<div class="Form-content--email">
			<label for="email">Tu email <span>*</span></label>
			<input
				type="text"
				name="email"
				id="email"
				placeholder="tu@email.com"
				bind:value={valueEmail}
			>
			{#if emailError}
				<div class="Form-content--error" in:fly out:fade>
					<div class="Form-content--error__element">
						Coloque un email correcto
					</div>
				</div>
			{/if}
		</div>
		<div class="Form-content--message">
			<label for="about" class="Form-content--label__message">Cuéntame de tu proyecto <span>*</span></label>
			<div class="Form__textarea">
				<textarea
					name="message"
					id="about"
					class="textarea"
					placeholder="Hablame de tu proyecto, minimo 75 caracteres"
					bind:value={valueMessage}
				/>
				<div class="Form__textarea--amount">
					{amountMessage}/75
				</div>
			</div>
			{#if messageError}
				<div class="Form-content--error" in:fly out:fade>
					<div class="Form-content--error__element">
						Escriba su mensaje con minimo 75 caracteres
					</div>
				</div>
			{/if}
		</div>
	</div>
	<input
		type="submit"
		value="Pide tu cotización"
		class="btn {disabled === true ? "disabled" : ""} "
		{disabled}
	>
</form>
<style>
	label{
		color: #fff;
	}
	span{
		margin-left: .3em;
	}
	@media(prefers-color-scheme: light){
		span{
			color: #000;
		}
	}
	@media(prefers-color-scheme: dark){
		span{
			color: #fff;
		}
	}
	input.btn{
		width: 100%;
	}
	.Form{
		width: 90%;
		margin: 0 auto;
		text-align: left;
	}
	.Form-content--name{
		margin-bottom: 1rem;
	}
	.Form-content--email{
		margin-bottom: 1rem;
	}
	.Form-content--message{
		margin-bottom: 2rem;
	}
	.Form__textarea{
		position: relative;
		margin-bottom: 1rem;
	}
	.Form__textarea--amount{
		position: absolute;
		bottom: 1rem;
		right: 1rem;
	}
	.textarea{
		margin-bottom: 0;
		min-height: 168px;
	}
	.Form-content--error{
		display: flex;
		justify-content: center;
		position: relative;
	}
	.Form-content--error__element{
		padding: 1rem 2rem;
		position:absolute;
		top: 0;
		color: var(--text-color);
		font-size: 1rem;
		background-color: var(--background-body);
		border-radius: 5px;
	}
	@media screen and (min-width:  768px) {
		input.btn{
			width: auto;
		}
		.Form{
			width: 75%;
		}
		.Form-content{
			display: flex;
			flex-wrap: wrap;
		}
		.Form-content--name{
			width: 50%;
			padding-right: 1rem;
		}
		.Form-content--email{
			width: 50%;
		}
		.Form-content--message{
			width: 100%;
		}
	}
</style>